import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialFormStackModule } from '@zerops/zerops/core/material-form-stack';
import { ZefFormsModule } from '@zerops/zef/forms';
import { ZefPasswordFieldModule } from '@zerops/zef/forms/modules';
import { PasswordChangeFormComponent } from './password-change-form.component';
import { PasswordChangeFormTranslationsModule } from './password-change-form.translations';

@NgModule({
  declarations: [ PasswordChangeFormComponent ],
  imports: [
    CommonModule,
    ZefFormsModule,
    MaterialFormStackModule,
    ZefPasswordFieldModule,
    PasswordChangeFormTranslationsModule
  ],
  exports: [ PasswordChangeFormComponent ]
})
export class PasswordChangeFormModule {

}
